import React from 'react'
import PropTypes from 'prop-types'

const getColorClassByStatus = status => {
  switch (status) {
    case '1':
    case '2':
    case '3':
    case '4':
    case '5':
      return 'color-success'
    case '6':
    case '7':
    case '8':
    case '9':
    case '10':
      return 'color-error'
    default:
      return ''
  }
}

const Name = ({ status, name, className, when }) => {
  return (
    <p>
      <strong className={`${className} ${getColorClassByStatus(when && status)}`}>
        {name}
      </strong>
    </p>
  )
}
Name.propTypes = {
  status: PropTypes.string,
  name: PropTypes.string,
  when: PropTypes.string,
  className: PropTypes.string
}
export default Name



// WEBPACK FOOTER //
// ./src/App/Header/Tracking/Item/Status/Name.js